import _ from 'lodash';
import moment from 'moment';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

// Material UI
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
//import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import PeopleIcon from '@material-ui/icons/People';
import TruckIcon from '@material-ui/icons/LocalShipping';

import AuthUserContainer from '../containers/AuthUser';
import EnhancedTableHead from '../components/table/EnhancedTableHead';

import UserContainer from '../containers/User';

import { isFiltered, sortTable, PureRecordRow } from '../libs/tableUtilities';
import { getGlobalClasses } from '../themes';
import FilterHeader from '../components/table/FilterHeader';
import localStorage from '../libs/localStorage';
import Note from '../components/Note';
import CheckIcon from '@material-ui/icons/Check';
import { post } from '../modules/utility';
import ErrorIcon from '@material-ui/icons/Error';
import red from '@material-ui/core/colors/red';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		table: {
			width: '100%',
			tableLayout: 'auto',
		},
		errorIcon: {
			width: 20,
			height: 20,
			color: red[500],
		},
	};
};

const nonDriverColumns = [
	{
		id: 'firstName',
		label: 'First name',
	},
	{
		id: 'lastName',
		label: 'Last name',
	},
	{
		id: 'email',
		label: 'Email',
	},
	{
		id: 'title',
		label: 'Title',
	},

	/*
  {
    id: "mobilePhoneNumber",
    label: "Mobile #",
  },
  */
	{
		id: 'userClocksInAndOut',
		label: 'Clocks In/Out',
	},
	{
		id: 'supervisorDisplay',
		label: 'Supervisor',
	},
	{
		id: 'dateCreated',
		label: 'Date Created',
	},
	{
		id: 'edit',
		label: 'Edit',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];

const driverColumns = [
	{
		id: 'firstName',
		label: 'First name',
	},
	{
		id: 'lastName',
		label: 'Last name',
	},
	{
		id: 'geoTabName',
		label: 'GeoTab Name',
	},
	{
		id: 'isModifiedDuty',
		label: 'Modified Duty',
	},
	{
		id: 'isTrainee',
		label: 'Is Trainee',
	},
	{
		id: 'supervisorDisplay',
		label: 'Supervisor',
	},
	{
		id: 'dateCreated',
		label: 'Date Created',
	},
	{
		id: 'edit',
		label: 'Edit',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
	/*
	{
	id: 'edit',
	label : 'Edit',
	style : {textAlign : 'center'},
	isNotSortable : true,
}
*/
];

function TabContainer({ children, dir }) {
	return (
		<Typography component="div" dir={dir} style={{ padding: 8 * 2 }}>
			{children}
		</Typography>
	);
}
TabContainer.propTypes = {
	children: PropTypes.node.isRequired,
	dir: PropTypes.string.isRequired,
};

class Users extends Component {
	constructor(props) {
		super(props);

		this.state = {
			driverOrder: 'asc',
			driverOrderBy: 'firstName',
			nonDriverOrder: 'asc',
			nonDriverOrderBy: 'firstName',
			filter: '',
			tabIndex: localStorage.getItem('user-tabIndex') || 0,
			filterMap: {},
			isViewDialogOpen: false,

			isInvoiceDocumentPopupOpen: false,
			invoiceDocumentsPoppedUp: [],
			isInvoicePdfPopupOpen: false,
			invoicePdfPoppedUp: undefined,

			pendingRows: undefined,
			issuedRows: undefined,
		};
	}

	componentDidMount() {
		if (!this.props.users.length) {
			this.props.searchUsers();
		}
		this.getUserToSupervisor();
	}

	getUserToSupervisor = () => {
		const { showErrors } = this.props;
		post({
			method: 'timeClockPermission.getUserToSupervisor',
			params: {},
			callback: (err, r) => {
				if (err) {
					return showErrors(err);
				}

				const userIdToSupervisor = _.get(r, 'userIdToSupervisor', {});
				this.setState({
					userIdToSupervisor,
				});
			},
		});
	};

	handleDriverSort = (orderBy) => {
		let order = 'desc';
		if (this.state.driverOrderBy === orderBy && this.state.driverOrder === 'desc') {
			order = 'asc';
		}
		this.setState({ driverOrder: order, driverOrderBy: orderBy });
	};

	handleNonDriverSort = (orderBy) => {
		let order = 'desc';
		if (this.state.nonDriverOrderBy === orderBy && this.state.nonDriverOrder === 'desc') {
			order = 'asc';
		}
		this.setState({ nonDriverOrder: order, nonDriverOrderBy: orderBy });
	};

	handleEdit = (userId) => {
		this.props.history.push(`/user/update/${userId}`);
	};
	handleEditDriver = (userId) => {
		this.props.history.push(`/user/updateDriver/${userId}`);
	};

	handleTabChange = (event, tabIndex) => {
		this.setTabIndex(tabIndex);
	};

	handleChangeTabIndex = (index) => {
		this.setTabIndex(index);
	};

	setTabIndex(index) {
		this.setState({ tabIndex: index });
		localStorage.setItem(`user-tabIndex`, index);
	}

	handleFilter = (event) => {
		this.setState({ filter: event.target.value });
	};

	render() {
		const { classes, users, theme, permissions } = this.props;
		const {
			driverOrder,
			driverOrderBy,
			nonDriverOrder,
			nonDriverOrderBy,
			filter,
			tabIndex,
			userIdToSupervisor,
		} = this.state;

		if (!permissions || !_.includes(permissions, 'canAddAndUpdateUsers')) {
			return <div>You do not have valid permissions to view this page.</div>;
		}
		if (!users || !userIdToSupervisor) {
			return <div>Fetching users...</div>;
		}

		let driverRows = [];
		let nonDriverRows = [];

		users.forEach((user) => {
			const {
				userId,
				firstName,
				lastName,
				email,
				geoTabName,
				role,
				dateCreated,
				title,
				mobilePhoneNumber,
				userClocksInAndOut,
				isModifiedDuty,
				isTrainee,
				exponentHrEmployeeName,
				isHidden,
			} = user;

			if (isHidden) {
				return;
			}

			const dateCreatedFormatted = moment(dateCreated).format('MMM Do, YYYY');

			const userClocksInAndOutDisplay = userClocksInAndOut ? (
				<>
					{' '}
					<CheckIcon />
					<span style={{ fontSize: 13, verticalAlign: 'super' }}>
						{exponentHrEmployeeName}
					</span>{' '}
				</>
			) : (
				''
			);

			const supervisor = userIdToSupervisor[userId];
			let supervisorDisplay = '';
			if (!supervisor) {
				supervisorDisplay = '-';
			} else if (supervisor.error) {
				supervisorDisplay = (
					<div>
						<ErrorIcon className={classes.errorIcon} />
						<span style={{ verticalAlign: 'super' }}>{supervisor.error}</span>
					</div>
				);
			} else if (supervisor.supervisorName) {
				supervisorDisplay = supervisor.supervisorName;
			} else {
				supervisorDisplay = 'Invalid';
			}

			const row = {
				userId,
				firstName,
				lastName,
				email,
				geoTabName,
				title,
				dateCreated,
				mobilePhoneNumber,
				dateCreatedFormatted,
				userClocksInAndOutDisplay,
				isModifiedDuty,
				isTrainee,
				exponentHrEmployeeName,
				supervisorDisplay,
			};

			if (isFiltered({ filter, row, fields: ['firstName', 'lastName', 'email'] })) {
				return;
			}

			//- Driver
			if (role === 'driver') {
				if (tabIndex !== 1) {
					return;
				}
				driverRows.push(row);
			} else {
				if (tabIndex !== 0) {
					return;
				}
				nonDriverRows.push(row);
			}
		}, []);

		driverRows = sortTable({
			rows: driverRows,
			order: driverOrder,
			orderBy: driverOrderBy,
		});
		nonDriverRows = sortTable({
			rows: nonDriverRows,
			order: nonDriverOrder,
			orderBy: nonDriverOrderBy,
		});

		return (
			<Fragment>
				<FilterHeader
					value={this.state.filter}
					onChange={this.handleFilter}
					label={'Users'}
					buttonText="Add User"
					url="/user/add"
					canMakeUpdates={true}
				/>

				<AppBar position="static" color="default">
					<Tabs
						value={this.state.tabIndex}
						onChange={this.handleTabChange}
						indicatorColor="primary"
						textColor="primary"
						variant="fullWidth"
						centered
					>
						<Tab label="Non-driver Users" icon={<PeopleIcon />} />
						<Tab label="Drivers" icon={<TruckIcon />} />
					</Tabs>
				</AppBar>
				<Paper className={classes.globalMainPaper}>
					<SwipeableViews
						axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
						index={this.state.tabIndex}
						onChangeIndex={this.handleChangeTabIndex}
					>
						<TabContainer dir={theme.direction}>
							<Table size="small" className={classes.table}>
								<EnhancedTableHead
									columns={nonDriverColumns}
									order={nonDriverOrder}
									orderBy={nonDriverOrder}
									onRequestSort={this.handleNonDriverSort}
								/>
								<TableBody>
									{nonDriverRows.map((row) => {
										return (
											<PureRecordRow hover className={classes.row} key={row.userId}>
												<TableCell>{row.firstName}</TableCell>
												<TableCell>{row.lastName}</TableCell>
												<TableCell>{row.email}</TableCell>
												<TableCell>{row.title}</TableCell>
												{/* <TableCell>{row.mobilePhoneNumber}</TableCell> */}
												<TableCell>{row.userClocksInAndOutDisplay}</TableCell>
												<TableCell>{row.supervisorDisplay}</TableCell>
												<TableCell>{row.dateCreatedFormatted}</TableCell>
												<TableCell align={'center'} style={{ whiteSpace: 'nowrap' }}>
													<Button
														className={classes.button}
														onClick={() => this.handleEdit(row.userId)}
													>
														Edit
													</Button>
												</TableCell>
											</PureRecordRow>
										);
									})}
								</TableBody>
							</Table>
						</TabContainer>
						<TabContainer dir={theme.direction}>
							<Note
								label={`All drivers are synced from GeoTabs and cannot be added here. 
								Most updates must be made in GeoTabs and will be synced with Sphere every 10 minutes.`}
							/>

							<Table size="small" className={classes.table}>
								<EnhancedTableHead
									columns={driverColumns}
									order={driverOrder}
									orderBy={driverOrder}
									onRequestSort={this.handleDriverSort}
								/>
								<TableBody>
									{driverRows.map((row) => {
										return (
											<PureRecordRow hover className={classes.row} key={row.userId}>
												<TableCell>{row.firstName}</TableCell>
												<TableCell>{row.lastName}</TableCell>
												<TableCell>{row.geoTabName}</TableCell>
												<TableCell>{row.isModifiedDuty && <CheckIcon />}</TableCell>
												<TableCell>{row.isTrainee && <CheckIcon />}</TableCell>
												<TableCell>{row.supervisorDisplay}</TableCell>
												<TableCell>{row.dateCreatedFormatted}</TableCell>
												<TableCell align={'center'} style={{ whiteSpace: 'nowrap' }}>
													<Button
														className={classes.button}
														onClick={() => this.handleEditDriver(row.userId)}
													>
														Edit
													</Button>
												</TableCell>
											</PureRecordRow>
										);
									})}
								</TableBody>
							</Table>
						</TabContainer>
					</SwipeableViews>
				</Paper>
			</Fragment>
		);
	}
}

Users.propTypes = {
	classes: PropTypes.object.isRequired,

	searchUsers: PropTypes.func.isRequired,
	users: PropTypes.array,

	permissions: PropTypes.array,
	order: PropTypes.string,
	orderBy: PropTypes.string,
	history: PropTypes.object,
	theme: PropTypes.object.isRequired,
	canMakeUpdates: PropTypes.bool,
};

export default _.flow([withStyles(styles, { withTheme: true }), UserContainer, AuthUserContainer])(
	Users
);
